import React, { Component } from 'react';
import {Link} from "react-router-dom";

import "./../styles/ventanaDecisionStyle.css";

export default class VentanaDecision extends Component {
    render() {
        return (
          <div className="VentanaDecision">
            <div className="card card-800">
              <div className="body-card">
                <div className="info-card">
                  <h1>¿Te encontrás en crisis?</h1>
                </div>
                <div className="buttons-card">
                  <Link to="/window/si/1" className="btnSelect si"><i className="material-icons-round">done</i>Estoy en crisis</Link>
                  <Link to="/window/no/1" className="btnSelect no"><i className="material-icons-round">clear</i>No estoy en crisis</Link>
                </div>
              </div>
              <div className="end-card">
                <Link to="/">VOLVER</Link>
              </div>
            </div>
          </div>
        )
    }
}
